import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { Link } from 'react-router';
import { __ } from 'react-i18n';
import {
  FlexCol,
  FlexColCenter,
  FlexRow,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { Title } from '../../Dsi/General/Title';
import InfoRow from './InfoRow';
import {
  DsiIconType,
  DsiSvgIcon,
  IconImg,
  Image,
  Picture,
  TextP,
  ZemplinLoaderWrapper,
} from '../../..';
import { ProductDetailPriceCart } from './ProductDetailPriceCart';
import { Select } from './AlternativeSelect';
import {
  formatPrice,
  prop,
  resolveCheapestInSlovakBasedOnCount,
  resolveGiftInSlovakBasedOnCount,
  resolveMostExpensiveInSlovakBasedOnCount,
  resolveProductInSlovakBasedOnCount,
} from '../../../utilities';
import { DsiTags as Tags } from '../General/Tags';
import { resolveProductUrl } from '../../../utilities/selectors';
import { AvailableGiftCardLabel } from './AvailableGiftCardLabel';

interface Props {
  product: any;
  price: number;
  oldPrice: number;
  currency: string;
  avail_id: number;
  availability: string;
  count: number;
  title: string;
  brand: any;
  brandImage?: string;
  brandLink?: string;
  plu: string;
  ean: string;
  sale: boolean;
  salePercentage: number;
  description: string;
  handleCountChange: (newValue) => void;
  addToFavoriteOpen: () => void;
  addToCart: any;
  watchDogOpen: () => void;
  image: string;
  alternativeProducts: any;
  crosssellProducts: any;
  isFetchingAlternatives: boolean;
  isFetchingBazar: boolean;
  bazarProducts: any;
  apiUrl: string;
  url: string;
  hasWatchDog?: boolean;
  hasFavourite?: boolean;
  canOrder?: boolean;
  forbiddenOrder?: boolean;
  loadingPrices?: boolean;
  showMoc?: boolean;
  showWithVat?: boolean;
  hasUser?: boolean;
  mocPrice: number;
  vocPrice: number;
  vocPriceWithoutVat: number;
  isB2B?: boolean;
  onStockCount?: number;
  saleEnded?: boolean;
  isPrelisting?: boolean;
  giftSale?: any;
  isSecondHand?: boolean;
  sales?: any[];
  isNew: boolean;
  condition?: any;
  conditionTextMapping?: any;
  isWaiting?: boolean;
  managerLink?: string;
  showCompareIcon?: boolean;
  isCompare?: boolean;
  addToCompare: (productId:string) => void;
}

function RightUpper({
  product,
  price,
  oldPrice,
  currency,
  avail_id,
  availability,
  handleCountChange,
  count,
  title,
  brand,
  brandImage,
  brandLink,
  plu,
  ean,
  sale,
  salePercentage,
  description,
  addToFavoriteOpen,
  addToCart,
  watchDogOpen,
  image,
  alternativeProducts,
  isFetchingAlternatives,
  url,
  apiUrl,
  hasWatchDog = true,
  hasFavourite = false,
  crosssellProducts,
  canOrder,
  forbiddenOrder,
  loadingPrices,
  showMoc,
  showWithVat,
  hasUser,
  mocPrice,
  vocPrice,
  vocPriceWithoutVat,
  isB2B,
  bazarProducts,
  onStockCount,
  saleEnded,
  isPrelisting,
  giftSale,
  isSecondHand,
  sales,
  isNew,
  condition,
  conditionTextMapping,
  isWaiting,
  managerLink,
  showCompareIcon,
  isCompare,
  addToCompare
}: Props) {
  const onSelectChange = e => {
    return;
  };
  const defaultOption: {
    image: string;
    name: string;
    plu: string;
    price: number;
    currency: string;
  } = {
    image: image
      ? `${apiUrl}/image?query=${image}&width=160&height=160&webp=0`
      : '/images/icons/placeholder.svg',
    name: `${title ? title : ''}`,
    plu: `${plu ? plu : ''}`,
    price,
    currency: `${currency}`,
  };

  const [isShowingAll, setIsShowingAll] = React.useState(true);
  const descSize = 10;
  const shortCategoryDescr =
    description && description.length > descSize
      ? description.substr(0, descSize) + '...'
      : null;
  const toggleShowingAll = () => {
    setIsShowingAll(!isShowingAll);
  };
  const warranty = prop(product, 'main_good.warranty');

  const actionPriceSale =
    sales &&
    sales.find(
      s => s.type === 'CHEAPEST_FREE' || s.type === 'MOST_EXPENSIVE_FREE',
    );

  const renderSaleFreeText = giftSaleProp => {
    return (
      <SaleText>
        {`${__('Kúpte')}`} <strong>{giftSaleProp.buy_count}</strong>{' '}
        {`${resolveProductInSlovakBasedOnCount(giftSaleProp.buy_count)} ${__(
          'a získate',
        )}`}
        <strong>
          {giftSaleProp.sale_count > 0
            ? ` ${giftSaleProp.sale_count}${__('ks')}`
            : ''}
        </strong>
        {/* {` ${resolveGiftInSlovakBasedOnCount(giftSale.sale_count)} ${__(
          'zadarmo',
        )}:`} */}
        {` ${__('darčeku')}`}
        {` ${__('zadarmo')}:`}
      </SaleText>
    );
  };

  const renderSalePriceText = giftSaleProp => {
    if (giftSaleProp.products_sale && giftSaleProp.products_sale.length) {
      if (giftSaleProp.products_sale.length === 1) {
        const productObj = giftSaleProp.products_sale[0];
        return (
          <SaleText>
            <>{`${__('Kúpou tohto produktu získate produkt')} ${
              productObj.name
            } ${__('za cenu')} `}</>
            <>
              {formatPrice(
                giftSaleProp.sale_unitprice,
                giftSaleProp.sale_currency,
              )}
            </>
          </SaleText>
        );
      } else {
        return (
          <SaleText>
            <>
              {__(
                'Kúpou tohto produktu získate jeden z produktov za zvýhodnenu cenu',
              )}
            </>
          </SaleText>
        );
      }
    } else {
      return <></>;
    }
  };

  return (
    <Wrapper>
      <InfoWrapper>
        <StyledTitle marginTop={0} marginBottom={16}>
          {`${title}`}
        </StyledTitle>
        {managerLink && (
          <a href={`${managerLink}&query=${plu}`} target="_blank">
            Report
          </a>
        )}
        <DescriptionCover>
          <Description isShowingAll={isShowingAll}>
            {!isShowingAll && shortCategoryDescr ? (
              <div dangerouslySetInnerHTML={{ __html: shortCategoryDescr }} />
            ) : (
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    description && description.length > 200
                      ? description.substr(0, 200) +
                        (!description.includes('<p>') ? '...' : '')
                      : description,
                }}
              />
            )}
          </Description>
          {/*
          {shortCategoryDescr && (
            <ShowMoreWrapper onClick={toggleShowingAll}>
              {__('Popis')}
              <IconImg
                cursor={'pointer'}
                width={8}
                height={4}
                marginLeft={9}
                rotate={isShowingAll ? 180 : 0}
                alt="arrow-icon"
                src={arrowSrc.toString()}
              />
            </ShowMoreWrapper>
          )}
          */}
        </DescriptionCover>
        <InfoRow
          title={__('Výrobca')}
          value={brand}
          noBorderBottom={true}
          hasUnderline={true}
          image={brandImage}
          link={brandLink}
        />
        {warranty ? <InfoRow title={__('Záruka')} value={warranty} /> : null}
        <InfoRow title={__('Kód tovaru')} value={plu} />
        <InfoRow noBorderBottom={true} title={__('EAN kód')} value={ean} />
      </InfoWrapper>

      {giftSale && (
        <SaleWrapper>
          <SaleTitleWrapper>
            <DsiSvgIcon
              icon={DsiIconType.gift}
              width={24}
              height={24}
              fill="orange"
              marginRight={16}
              title={__('Darček ku produktu')}
            />
            <SaleTitle>{giftSale.sale_name}</SaleTitle>
            {giftSale.more_info_link ? (
              <>
                <div> (</div>
                <MoreInfoLink href={giftSale.more_info_link}>
                  {__('viac info')}
                </MoreInfoLink>
                <div>)</div>
              </>
            ) : (
              <></>
            )}
          </SaleTitleWrapper>
          {giftSale.description ? (
            <SaleText
              dangerouslySetInnerHTML={{ __html: giftSale.description }}
            />
          ) : giftSale.type === 'GIFTS_FOR_PRICES' ? (
            renderSalePriceText(giftSale)
          ) : (
            renderSaleFreeText(giftSale)
          )}
          {giftSale.products_sale && giftSale.products_sale.length > 0 && (
            <SaleGiftsWrapper>
              {giftSale.products_sale.slice(0, 6).map(gift => (
                <SaleGift
                  to={`/${prop(gift, 'publish.0.product_url') ||
                    prop(gift, 'url')}`}
                  key={gift.product_id}
                >
                  <Picture
                    alt={`${__('Obrázok ku produktu')} ${
                      gift.name ? gift.name : ''
                    }`}
                    image={gift.picture}
                    width={80}
                    height={80}
                  />
                  <SaleGiftName>{gift.name}</SaleGiftName>
                </SaleGift>
              ))}
            </SaleGiftsWrapper>
          )}
        </SaleWrapper>
      )}

      {actionPriceSale && (
        <ActionSaleWrapper>
          <SaleTitleWrapper>
            <DsiSvgIcon
              icon={DsiIconType.percentage}
              width={24}
              height={24}
              fill="#0089c7"
              marginRight={16}
              title={__('Akcia ku produktu')}
            />
            <ActionSaleTitle>{actionPriceSale.sale_name}</ActionSaleTitle>
          </SaleTitleWrapper>
          <SaleText>
            {`${__('Kúpte')}`} <strong>{actionPriceSale.buy_count}</strong>{' '}
            {`${resolveProductInSlovakBasedOnCount(
              actionPriceSale.buy_count,
            )} ${__('z danej ponuky')} ${__('a')} `}
            <strong>
              {actionPriceSale.sale_count > 0
                ? ` ${actionPriceSale.sale_count} ${
                    actionPriceSale.type === 'MOST_EXPENSIVE_FREE'
                      ? resolveMostExpensiveInSlovakBasedOnCount(
                          actionPriceSale.sale_count,
                        )
                      : resolveCheapestInSlovakBasedOnCount(
                          actionPriceSale.sale_count,
                        )
                  } ${__('ks')}`
                : ''}
            </strong>
            {/* {` ${resolveGiftInSlovakBasedOnCount(actionPriceSale.sale_count)} ${__(
              'zadarmo',
            )}:`} */}
            {` ${__(' máte')} ${__('zadarmo')}`}
          </SaleText>
          {!!prop(actionPriceSale, 'more_info_link') && (
            <ActionSaleButtonLink
              href={`${prop(actionPriceSale, 'more_info_link')}`}
            >
              {__('Zobraziť ponuku')}
            </ActionSaleButtonLink>
          )}
        </ActionSaleWrapper>
      )}

      {prop(bazarProducts, 'products.length') > 0 && (
        <Alternatives>
          <SelectTitle>{__('Bazár')}</SelectTitle>
          <Select
            onChange={onSelectChange}
            products={bazarProducts.products}
            value={defaultOption}
            apiUrl={apiUrl}
            showMoc={showMoc}
            showWithVat={showWithVat}
            loadingPrices={loadingPrices}
          />
        </Alternatives>
      )}

      {isFetchingAlternatives ? (
        <ZemplinLoaderWrapper height={88} />
      ) : (alternativeProducts && alternativeProducts.total) > 0 ? (
        <Alternatives>
          <SelectTitle>{__('Farebné prevedenia')}</SelectTitle>
          <Select
            onChange={onSelectChange}
            products={alternativeProducts.products}
            value={defaultOption}
            apiUrl={apiUrl}
            showMoc={showMoc}
            showWithVat={showWithVat}
            loadingPrices={loadingPrices}
          />
        </Alternatives>
      ) : (
        <></>
      )}
      {product?.available_gift_cards?.length ? (
        <AvailableGiftCardLabel
          product={product}
          price={price}
          oldPrice={isSecondHand ? 0 : oldPrice}
          currency={currency}
          vocPrice={vocPrice}
          vocPriceWithoutVat={vocPriceWithoutVat}
          mocPrice={mocPrice}
          isB2B={isB2B}
        />
      ) : (
        <></>
      )}

      {true && (
        <ProductDetailPriceCart
          canOrder={canOrder}
          forbiddenOrder={forbiddenOrder}
          product={product}
          price={price}
          oldPrice={isSecondHand ? 0 : oldPrice}
          sale={sale}
          salePercentage={salePercentage}
          avail_id={avail_id}
          availability={availability}
          currency={currency}
          count={count}
          handleCountChange={handleCountChange}
          addToFavoriteOpen={addToFavoriteOpen}
          addToCart={addToCart}
          watchDogOpen={watchDogOpen}
          loadingPrices={loadingPrices}
          hasUser={hasUser}
          vocPrice={vocPrice}
          vocPriceWithoutVat={vocPriceWithoutVat}
          mocPrice={mocPrice}
          isB2B={isB2B}
          onStockCount={onStockCount}
          saleEnded={saleEnded}
          isPrelisting={isPrelisting}
          isNew={isNew}
          condition={condition}
          conditionTextMapping={conditionTextMapping}
          isWaiting={isWaiting}
          showCompareIcon={showCompareIcon}
          isCompare={isCompare}
          addToCompare={addToCompare}
        />
      )}
      <WatchShare hasWatchDog={!hasWatchDog}>
        {hasWatchDog && (
          <WatchItem title={__('Strážiť produkt.')} onClick={watchDogOpen}>
            <IconImg src={'/assets/dsi/dog.svg'} />
            <DogText>{__(`Strážny pes`)}</DogText>
          </WatchItem>
        )}
        <WatchShareItem
          to={`https://www.facebook.com/sharer/sharer.php?u=https://www.edsi.sk${url}`}
          target="_blank"
        >
          <IconImg
            alt={__('Zdieľať s priateľmi')}
            title={__('Zdieľať s priateľmi')}
            src={'/assets/dsi/share.svg'}
          />
          <ShareText>{__('Zdieľať s priateľmi')}</ShareText>
        </WatchShareItem>
      </WatchShare>
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  width: 100%;
  max-width: ${rem(600)};
  border-left: ${({ theme }) => theme.borders.primary};

  ${({ theme }) => theme.mediab.l925`
    max-width: 100%;
  `}
`;

const InfoWrapper = styled(FlexCol)`
  padding: ${rem(24)};
  padding-bottom: 0;

  ${({ theme }) => theme.mediab.l925`
    padding-left: ${rem(16)};
    padding-right: ${rem(16)};
  `}
`;

const SaleWrapper = styled(FlexCol)`
  padding: ${rem(24)} ${rem(24)};
  background: ${({ theme }) => '#ffa5004d'};
`;

const ActionSaleWrapper = styled(SaleWrapper)`
  background: ${({ theme }) => '#c5ecfd'};
`;

const SaleTitleWrapper = styled(FlexRowCenterVertical)`
  margin-bottom: ${rem(16)};
`;

const SaleTitle = styled.h3`
  margin: 0;
  font-size: ${rem(20)};
  color: ${({ theme }) => '#ffa500'};
`;

const ActionSaleTitle = styled(SaleTitle)`
  color: ${({ theme }) => '#0089c7'};
`;

const SaleText = styled(TextP)``;

const SaleGiftsWrapper = styled(FlexRowCenterVertical)`
  margin-top: ${rem(16)};
  background: white;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  gap: ${rem(16)};
  padding: ${rem(16)};
  border-radius: ${rem(4)};
  flex-flow: row wrap;

  ${({ theme }) => theme.mediab.m580`
    justify-content: center;
    gap: ${rem(32)};
  `}
`;

const ActionSaleButtonLink = styled.a`
  color: ${({ theme }) => '#c5ecfd'};
  background: ${({ theme }) => '#0089c7'};
  padding: ${rem(8)} ${rem(24)};
  font-weight: 600;
  margin-top: ${rem(16)};
  border-radius: ${rem(4)};
  box-shadow: ${({ theme }) => theme.boxShadow.default};
  width: fit-content;
  height: ${rem(40)};
`;

const SaleGift = styled(Link)`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  width: ${rem(160)};
  &:hover {
    text-decoration: underline;
  }
`;

const SaleGiftName = styled(TextP)`
  text-align: center;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  overflow: hidden;
  margin-top: ${rem(8)};
`;

const Alternatives = styled.div`
  padding: ${rem(24)};

  ${({ theme }) => theme.mediab.l925`
    padding: ${rem(32)} ${rem(16)} ${rem(24)} ${rem(16)};
  `}
`;

const SelectTitle = styled(TextP)`
  margin-bottom: ${rem(8)};
`;

const Description = styled.div<{ isShowingAll?: boolean }>`
  font-size: ${rem(16)};
  font-weight: 400;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  line-height: ${rem(24)};
  display: inline-block;
  margin-right: ${rem(8)};

  ${({ theme }) => theme.mediab.l925`
    margin-bottom: ${rem(8)};
    display: ${props => (props.isShowingAll ? 'block' : 'none')};

    p {
      margin-bottom: 0;
      margin-top: 0;
    }
  `}
`;

const WatchShare = styled(FlexRowCenterVertical)<{ hasWatchDog?: boolean }>`
  padding: ${rem(24)};
  justify-content: ${props =>
    props.hasWatchDog ? 'flex-end' : 'space-between'};

  ${({ theme }) => theme.mediab.l925`
    padding-left: ${rem(16)};
    padding-right: ${rem(16)};
  `}
`;

const WatchShareItem = styled(Link)`
  display: flex;
  flex-direction: row;
  text-decoration: none;
  &:hover {
    color: ${({ theme }) => theme.colors.textPrimary};
    text-decoration: underline;
  }
`;

const WatchItem = styled(FlexRowCenterVertical)`
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

const ShareText = styled(TextP)`
  font-size: ${rem(16)};
  margin-left: ${rem(8)};
  ${({ theme }) => theme.mediab.s450`
    display: none;
  `}
`;

const DogText = styled(TextP)`
  font-size: ${rem(16)};
  margin-left: ${rem(8)};
  font-weight: 500;
`;

const StyledTitle = styled(Title)`
  font-weight: 500;
  font-size: ${rem(36)};
  line-height: ${rem(48)};

  ${({ theme }) => theme.mediab.l925`
    font-size: ${rem(24)};
    line-height: ${rem(28)};
    margin-bottom: ${rem(8)};
  `}
`;

const ShowMoreWrapper = styled(FlexRowCenterVertical)`
  font-size: ${rem(16)};
  line-height: ${rem(20)};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textPrimary};
  width: fit-content;
  cursor: pointer;
  margin: 0;
  width: initial;
  display: inline-flex;

  ${({ theme }) => theme.mediab.l925`
    display: block;
  `}
`;

const DescriptionCover = styled.div`
  margin-bottom: ${rem(12)};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;

  ${({ theme }) => theme.mediab.l925`
    display: block;
    margin-bottom: ${rem(20)};
  `}
`;

const MoreInfoLink = styled.a``;

export { RightUpper as DsiRightUpper };
